import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import React from "react";

import {Map} from "./Map";

const useStyles = makeStyles(
  () => ({
    // careerBox: {
    //   // background: "white",
    //   height: "100%",
    //   // padding: "0 50px 10px 50px",
    //   width: "900px",
    //   zIndex: "2",
    // },
    aboutUsCard: {
      // background: "white",
      height: "100%",

      paddingRight: "1rem",
      // paddingLeft: "3.5rem",
      // padding: "0 50px 10px 50px",
      width: "900px",
    },
    content: {
      fontFamily: "sans-serif",
      fontSize: "16px",
      marginBottom: "16px",
      textAlign: "left",
      width: "100%",
    },
    contentHeader: {
      fontFamily: "sans-serif",
      fontSize: "22px",
      fontWeight: "bold",
      margin: "10px 0",
      textAlign: "left",
      width: "100%",
    },
    infoBar: {
      display: "flex",
      margin: "15px 0",
      width: "100%",
    },
    infoContent: {
      fontFamily: "sans-serif",
      fontSize: "16px",
    },
    infoHeader: {
      fontFamily: "sans-serif",
      fontSize: "16px",
      minWidth: "100px",
    },
    line: {
      background: "#1c1c1c",
      height: "8px",
      top: "0px",
      width: "125px",
    },
    // locationBox: {
    //   // background: "white",
    //   height: "100%",
    //   // padding: "0 50px 10px 50px",
    //   width: "900px",
    // },
    subAboutBox: {
      alignItems: "start",
      backgroundColor: "#f7f7f7",
      display: "flex",
      flex: "1 0 100%",
      justifyContent: "start",
      // margin: "7px",
    },
    title2: {
      fontSize: "3rem",
      fontWeight: "bold",
    },
  }),
  {
    name: "About",
  }
);

export const About: React.FC = () => {
  const classes = useStyles();

  return (
    <Stack
      id="about-us"
      direction="column"
      spacing={5}
      // className={classes.aboutBox}
      sx={{marginInline: {md: "3rem", sm: "0.5rem", xs: "0.1rem"}}}
    >
      <Typography className={classes.title2}>About Us</Typography>

      <div className={classes.subAboutBox}>
        <Box
          className={classes.aboutUsCard}
          sx={{pl: {md: "3.5rem", sm: "1rem", xs: "1rem"}}}
        >
          <div className={classes.line} />

          <div className={classes.contentHeader}>Company Info</div>

          <div className={classes.infoBar}>
            <div className={classes.infoHeader}>Name</div>

            <div className={classes.infoHeader}>
              Lever Data Solutions Limited
            </div>
          </div>

          <div className={classes.infoBar}>
            <div className={classes.infoHeader}>Product</div>

            <div className={classes.infoContent}>
              Checkafy, a FMCG mobile application aggregating FMCG data to
              promote a smart shopping habit for consumers, and assist retailers
              and manufacturers in sales and marketing of merchandise.
            </div>
          </div>

          <div className={classes.infoBar}>
            <div className={classes.infoHeader}>Contact</div>

            <a className={classes.infoContent} href="mailto:info@checkafy.com">
              info@checkafy.com
            </a>
          </div>
        </Box>
      </div>

      <div className={classes.subAboutBox}>
        <Box
          className={classes.aboutUsCard}
          sx={{pl: {md: "3.5rem", sm: "1rem", xs: "1rem"}}}
        >
          <div className={classes.line} />

          <div className={classes.contentHeader}>Career</div>

          <div className={classes.content}>
            Have your ever imagined our future E-commerce? Come join to us to
            develop our future market we have dreamed about.
          </div>

          <div className={classes.content}>
            Interested talents are welcome to send your resume with target
            position to <a href="mailto:hr@checkafy.com">hr@checkafy.com</a>
          </div>
        </Box>
      </div>

      <div className={classes.subAboutBox}>
        <Box
          className={classes.aboutUsCard}
          sx={{pl: {md: "3.5rem", sm: "1rem", xs: "1rem"}}}
        >
          <div className={classes.line} />

          <div className={classes.contentHeader}>Address</div>

          <div className={classes.content}>
            Unit 513, 5/F, Building 19W, No. 19 Science Park West Avenue, Hong
            Kong Science Park, Pak Shek Kok, N.T., Hong Kong
          </div>

          <Map />
        </Box>
      </div>
    </Stack>
  );
};
